import { Command } from 'cmdk';
import cx from 'classnames';
import { Loader } from '@jjj/components';
import { getLanguageByCountry, t } from 'src/i18n';
import { LoaderWrapper, LoadMoreWrapper } from '../globalSearch.style';
import ResultItem from '../resultItem/resultItem';
import { getIconByType } from '../utils';
import GlobalSearchEmpty from '../globalSearchEmpty/globalSearchEmpty';
import GlobalSearchRecent from '../globalSearchRecent/globalSearchRecent';

const GlobalSearchResults = ({
  isSearchLoading,
  results,
  recent,
  toggleGlobalSearchVisibility,
  clickItem,
  listRef,
  onScroll,
  isLoadMoreLoading,
  query,
}) => {
  const locale = getLanguageByCountry();

  const shouldShowRecent = () => {
    return (results === null && recent?.length) || (results?.length === 0 && query === '');
  };

  const shouldShowEmpty = () => {
    return results?.length === 0 && !isSearchLoading && query !== '';
  };

  const commandListClassNames = cx({
    ['command-list-empty']: recent?.length === 0 || results?.length === 0,
  });

  return (
    <Command.List ref={listRef} onScroll={onScroll} className={commandListClassNames}>
      {isSearchLoading && (
        <LoaderWrapper>
          <Loader />
          <span className="search-label">{t('dash.globalSearch.searching_label')}</span>
        </LoaderWrapper>
      )}

      {shouldShowEmpty() && (
        <Command.Empty>
          <GlobalSearchEmpty />
        </Command.Empty>
      )}

      <Command.Group heading={shouldShowRecent() && <GlobalSearchRecent recent={recent} />} forceMount="true">
        {shouldShowRecent() &&
          recent?.map(item => {
            return (
              <ResultItem
                key={item?.id}
                value={`${item.title}-${item.id}`}
                subtitle={item?.type}
                icon={getIconByType(item?.type, item?.image)}
                toggleGlobalSearchVisibility={toggleGlobalSearchVisibility}
                id={item?.id}
                type={item?.type}
                clickItem={clickItem}
                documentId={item?.document_id}
                company={item?.company}
                ancestors={item?.breadcrumbs?.[locale]}
                workerIdentityId={item?.worker_identity_id}
              >
                {item.title}
              </ResultItem>
            );
          })}
        {results?.length > 0 &&
          results.map(item => {
            return (
              <ResultItem
                key={item?.id}
                value={`${item.title}-${item.id}`}
                subtitle={item?.type}
                icon={getIconByType(item?.type, item?.image)}
                toggleGlobalSearchVisibility={toggleGlobalSearchVisibility}
                id={item?.id}
                type={item?.type}
                clickItem={clickItem}
                documentId={item?.document_id}
                company={item?.company}
                ancestors={item?.breadcrumbs?.[locale]}
                workerIdentityId={item?.worker_identity_id}
              >
                {item.title}
              </ResultItem>
            );
          })}
      </Command.Group>

      {isLoadMoreLoading && (
        <LoadMoreWrapper className="test123456">
          <Loader position="static" />
        </LoadMoreWrapper>
      )}
    </Command.List>
  );
};

export default GlobalSearchResults;
